import type { SymbolDefinition } from "../types.ts";

export const circuitBreaker1p: SymbolDefinition = {
  id: "ep-cb-1p",
  familyKey: "circuit_breaker",
  deviceKind: "circuit_breaker",
  version: "0.1.0",
  label: { sv: "Dvärgbrytare 1-polig", en: "MCB 1-pole" },
  description: { sv: "Enpolig dvärgbrytare.", en: "Single-pole miniature circuit breaker." },
  viewBox: "0 0 24 24",
  svg: `
    <g fill="none" stroke="currentColor" stroke-width="1.5">
      <rect x="6" y="6" width="12" height="12" rx="1"/>
      <line x1="12" y1="2" x2="12" y2="6"/>
      <line x1="12" y1="18" x2="12" y2="22"/>
      <text x="12" y="14" text-anchor="middle" font-size="6" fill="currentColor" stroke="none">Q</text>
    </g>
  `,
  terminals: [
    { id: "in", kind: "phase", label: "L1", position: "top", offset: 0.5 },
    { id: "out", kind: "phase", label: "T1", position: "bottom", offset: 0.5 },
  ],
  designationPrefix: "Q",
  searchKeywords: ["brytare", "mcb"],
};
